import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import { supabase } from './lib/supabase';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AnnouncementBar from './components/AnnouncementBar';
import Home from './pages/Home';
import Search from './pages/Search';
import Profile from './pages/Profile';
import WriteReview from './pages/WriteReview';
import { Login, Signup, ResetPassword } from './pages/Auth';
import ManagerDashboard from './pages/ManagerDashboard';
import TenantDashboard from './pages/TenantDashboard';
import Pricing from './pages/Pricing';
import FindAndReview from './pages/FindAndReview';
import Admin from './pages/Admin';
import About from './pages/About';
import CreditConsent from './pages/CreditConsent';
import CreditReport from './pages/CreditReport';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Restore session on page load
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser({
          id: session.user.id,
          email: session.user.email,
          name: session.user.user_metadata?.name || session.user.email.split('@')[0],
          role: session.user.user_metadata?.role || 'tenant',
        });
      }
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser({
          id: session.user.id,
          email: session.user.email,
          name: session.user.user_metadata?.name || session.user.email.split('@')[0],
          role: session.user.user_metadata?.role || 'tenant',
        });
      } else {
        setUser(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setUser(null);
  };

  const getDashboard = () => {
    if (!user) return null;
    return user.role === 'manager' ? '/manager-dashboard' : '/tenant-dashboard';
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F5EFE3' }}>
      <div style={{ fontFamily: "'DM Serif Display', serif", fontSize: 32, color: '#0F2C4E', fontWeight: 400 }}>Renter<span style={{ color: '#C9972A' }}>Rep</span></div>
    </div>
  );

  return (
    <BrowserRouter>
      <Navbar user={user} onSignOut={handleSignOut} dashboardPath={getDashboard()} />
      <AnnouncementBar />
      <Routes>
        <Route path="/" element={<Home user={user} />} />
        <Route path="/search" element={<Search user={user} />} />
        <Route path="/find" element={<FindAndReview user={user} />} />
        <Route path="/profile/:id" element={<Profile user={user} />} />
        <Route path="/review/:id" element={<WriteReview user={user} />} />
        <Route path="/login" element={<Login onLogin={setUser} />} />
        <Route path="/signup" element={<Signup onLogin={setUser} />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/manager-dashboard" element={<ManagerDashboard user={user} />} />
        <Route path="/tenant-dashboard" element={<TenantDashboard user={user} />} />
        <Route path="/dashboard" element={<ManagerDashboard user={user} />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={<Admin user={user} />} />
        <Route path="/credit/consent/:requestId" element={<CreditConsent user={user} />} />
        <Route path="/credit/report/:requestId" element={<CreditReport user={user} />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
